import React from 'react';

/**
 * Names the page currently open in the editor.
 *
 * The number badge is the same one the rail puts on its rows, so the two panes
 * point at each other without anyone having to compare titles. It replaces the
 * plain accent bar that used to sit here: it carries the same green and says
 * something as well. An h2 — the page's h1 is the editor itself.
 */
export function ActivePageHeading({ title, meta, number }) {
  return (
    <div className="mb-5 flex items-center gap-3 border-b border-slate-200 dark:border-slate-700 pb-4">
      {number ? (
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-green-500 text-base font-bold tabular-nums text-white">
          {number}
        </span>
      ) : (
        <span className="h-10 w-1.5 shrink-0 rounded-full bg-green-500" />
      )}
      <div className="min-w-0">
        <h2 className="truncate text-xl sm:text-2xl font-bold text-slate-900 dark:text-slate-100">
          {title}
        </h2>
        {meta && <p className="truncate text-sm text-slate-500 dark:text-slate-400">{meta}</p>}
      </div>
    </div>
  );
}
